<div>
  <h2 class="mb-4 text-lg font-semibold">Upload this question attempt to a dataset</h2>

  <dojo-text-input [label]="datasetLabelTpl" placeholder="dataset-name" [formCtrl]="datasetNameCtrl" class="w-full" />
  <ng-template #datasetLabelTpl>
    <div class="flex w-full items-center justify-between gap-2">
      <span>Dataset name</span>
      @if (datasetPresets().length > 0) {
        <div class="flex gap-2">
          @for (preset of datasetPresets(); track preset) {
            <dojo-button [size]="'xs'" (click)="datasetNameCtrl.setValue(preset)">{{ preset }}</dojo-button>
          }
        </div>
      }
    </div>
  </ng-template>

  <div class="mt-4 flex gap-2">
    <dojo-button [fill]="'outline'" class="w-full" (click)="closeDialog()">Cancel</dojo-button>
    <dojo-button class="w-full" [disabled]="!datasetNameCtrl.valid" [pending]="loading()" (click)="uploadDatasetRow()">
      Upload
    </dojo-button>
  </div>
</div>
